import React from 'react'
import ContactForm from '../Form/ContactForm'

const TwoSectionForm = ({data}) => {
  return (
    <>
    <ContactForm fields={data.fields} /></>
  )
}

export default TwoSectionForm